import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message,
  size = 40 
}) => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        minHeight: 200,
      }}
    >
      <CircularProgress
        size={size}
        thickness={4}
        aria-label={message || t('loading')}
      />
      {message && (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ marginTop: 2 }}
          aria-live="polite"
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;